import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import { Tab } from '@headlessui/react';
import CargomaticTab from 'components/v2/navs/Tab';
import { useTranslation } from 'react-i18next';
import { useExpiredQuickPayContracts, useQuickPayContracts, useTermsAndConditions } from 'hooks/quick-pay/useContracts';
import { isProd } from 'helpers/helper_functions';
import Sidebar from '../../../carrier/AdminSidebar';
import Active from './Active';
import Expired from './Expired';
import History from './History';
import { getCustomerV2 } from '../../../../../utils/CustomersAPIUtils';
const QuickPay = () => {
    const { id: carrierId } = useParams();
    const { t } = useTranslation();
    const [carrier, setCarrier] = useState(null);
    const [activeContracts, setActiveContracts] = useState([]);
    const [scheduledContracts, setScheduledContracts] = useState([]);
    const { data: termsAndConditions, isLoading: termsAndConditionsLoading } = useTermsAndConditions();
    const { data, isSuccess, isLoading: activeLoading, } = useQuickPayContracts(carrierId);
    const { data: expiredContracts, isLoading: expiredLoading } = useExpiredQuickPayContracts(carrierId);
    const fetchUser = async () => {
        const user = await getCustomerV2(carrierId);
        setCarrier(user);
    };
    const populateData = (contractData) => {
        const contracts = contractData.reduce((acc, contract) => {
            if (contract.type === 'active') {
                acc.active = contract.items;
            }
            if (contract.type === 'scheduled') {
                acc.scheduled = contract.items;
            }
            return acc;
        }, { active: [], scheduled: [] });
        if (contracts.active) {
            setActiveContracts(contracts.active);
        }
        if (contracts.scheduled) {
            setScheduledContracts(contracts.scheduled);
        }
    };
    useEffect(() => {
        fetchUser();
    }, []);
    useEffect(() => {
        if (isSuccess && data) {
            populateData(data);
        }
    }, [data]);
    const tabs = [
        {
            slug: 'active',
            name: t('ACTIVE'),
        },
        {
            slug: 'expired',
            name: t('EXPIRED'),
        },
        {
            slug: 'history',
            name: t('HISTORY'),
        },
    ];
    const renderSidebar = () => (React.createElement(Sidebar, { userId: carrierId, activePage: "quickpay" }));
    const breadcrumbs = {
        pages: [
            {
                name: (carrier === null || carrier === void 0 ? void 0 : carrier.name) || t('CARRIER'),
                href: `/users/${carrierId}`,
                current: false,
            },
            {
                name: 'QuickPay',
                href: `/users/${carrierId}/carrier-settings/quick-pay`,
                current: true,
            },
        ],
    };
    return (React.createElement(LayoutWithSidebar, { sidebar: renderSidebar, breadcrumbs: breadcrumbs, className: "py-4" },
        React.createElement("div", { className: "mb-6 col-span-1", "data-testid": "quick-pay-page" },
            React.createElement(Tab.Group, null,
                React.createElement(Tab.List, null,
                    React.createElement("div", { className: "space-x-4" }, tabs.map((tab) => (React.createElement(CargomaticTab, { tab: tab }))))),
                React.createElement(Tab.Panels, { className: "mt-6" },
                    React.createElement(Tab.Panel, null,
                        React.createElement(Active, { id: carrierId, activeContracts: activeContracts, scheduledContracts: scheduledContracts, loading: activeLoading || termsAndConditionsLoading, termsAndConditions: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.items })),
                    React.createElement(Tab.Panel, null,
                        React.createElement(Expired, { id: carrierId, data: expiredContracts, loading: expiredLoading })),
                    !isProd() && (React.createElement(Tab.Panel, null,
                        React.createElement(History, null))))))));
};
export default QuickPay;
